import React from "react"
import Background from '../modules/background.svg';
import Play from '../modules/play.svg';
import Pause from '../modules/pause.svg';

export default function TrackSearchResult({ track, chooseTrack, playingTrack }) {
  function handlePlay() {
    chooseTrack(track)
  }

  const isPlaying = playingTrack?.uri === track.uri;

  return (
    <div className="track-container" onClick={handlePlay}>
      <img
        src={track.albumUrl}
        className="track-image"
        alt={track.title}
      />

      <div
        className="track-info-container"
        style={{
          backgroundImage: `url(${Background})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="track-info">
        {track.pointsEnabled && (
          <div class="track-points">
            <div class="track-points-ico">
            </div>
            <div class="track-points-value">
              {track.pointsFor30Sec + track.pointsForHalf + track.pointsForFull}
            </div>
          </div>
          )}
          <div className="track-title">{track.title}</div>
          <div className="track-artist">{track.artist}</div>
        </div>

        <button className="play-button">
          <img
            src={isPlaying ? Pause : Play}
            alt={isPlaying ? "Pause" : "Play"}
            className="play-pause-icon"
          />
        </button>
      </div>
    </div>
  )
}
